<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content" v-loading.lock="loading">
        <div class="main-title">展商手册</div>
        <div v-if="detail.deadline" class="main-sub pd">
          提交截止日期：{{ detail.deadline }}
        </div>
        <div class="details-tips">
          <p>
            请您务必注意认真阅读，并且注意每个表格的截止日期，请下载并提前填写完成，以传真或电子邮件发至各相关单位。
          </p>
          <p>如有问题，请联系对应人员：</p>
          <p>工程搭建类：孙璐 010-84662797</p>
          <p>会刊及现场广告类：杨爱莲 010-84662129</p>
        </div>
        <el-form ref="form" label-width="100px" style="margin-top: 30px">
          <el-form-item label="标题：">
            <el-input
              v-model="searchs.title"
              placeholder="请输入标题"
            ></el-input>
            <!-- <el-select
              v-model="searchs.cid"
              filterable
              clearable
              placeholder="请选择届数"
            >
              <el-option
                v-for="item in lists"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select> -->
            <el-button
              size="medium"
              class="search"
              type="primary"
              @click="changeSession"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
        <el-row type="flex">
          <el-col :sm="24" :md="24" :lg="24" :xl="24" class="template-div">
            <div ref="templateHeight">
              <div class="t_list" v-if="fileList.length > 0">
                <div
                  class="template-list"
                  v-for="(item, index) in fileList"
                  :key="index"
                >
                  <el-image
                    class="file-icon"
                    :src="fileIcon"
                    fit="cover"
                  ></el-image>
                  <div class="te-left">
                    <p class="file-name">{{ item.title }}</p>
                    <p class="file-time">截止时间：{{ item.deadline }}</p>
                  </div>
                  <div
                    class="te-right"
                    @click="down($imgOssUrl + item.file.substring(1))"
                  >
                    下载
                  </div>
                </div>
              </div>
              <nodata v-if="fileList.length == 0"></nodata>
            </div>
          </el-col>
        </el-row>
        <div class="conf-btn flex">
          <!-- 可跳过需要验证 -->
          <template v-if="detail.is_skip == 1 && detail.is_verify == 1">
            <div class="btn" @click="next('skip')">跳过</div>
            <div class="btn next-btn" @click="next('next')">下一步</div>
          </template>
          <!-- 可跳过无需验证 -->
          <template v-if="detail.is_skip == 1 && detail.is_verify == 0">
            <!-- 24.9.1 已知悉改成下一步 dxm-->
            <div class="btn next-btn" @click="next('known')">下一步</div>
          </template>
          <!-- 不可跳过需要验证 -->
          <template v-if="detail.is_skip == 0 && detail.is_verify == 1">
            <div class="btn next-btn" @click="next('next')">下一步</div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fileShareList, skipOrReadStep } from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
import nodata from "../components/nodata.vue"; //暂无数据
export default {
  components: { top, navMenu, nodata },
  name: "exhibitorManual",
  data() {
    return {
      loading: false,
      active: 2,
      fileIcon: require("../assets/file_img.jpg"), // pdf的图标
      fileList: [], //pdf数据
      height: "500",
      searchs: { title: "" },
      detail: {},
      lists: [],
    };
  },
  mounted() {
    this.getData();
  },
  watch: {},
  methods: {
    getData() {
      let stepMenuList = JSON.parse(localStorage.getItem("menu"));
      this.stepMenuList = stepMenuList;
      var index = stepMenuList.findIndex(function (item) {
        return item.link_url == "exhibitorManual";
      });
      this.detail = stepMenuList[index];
      this.active = index;
      this.getSource();
    },
    // 获取下载及其他列表
    getSource() {
      this.loading = true;
      let data = this.$qs.stringify(this.searchs);
      fileShareList(data)
        .then((res) => {
          this.loading = false;
          console.log(res, "======获取资源");
          if (res.data.code == 1) {
            let { data } = res.data;
            this.fileList = data.lists;

            setTimeout(() => {
              let height = this.$refs.templateHeight.offsetHeight;
              if (height > 500) {
                this.height = height;
              }
            }, 50);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 查询
    changeSession() {
      this.getSource(this.searchs.cid);
    },
    // 跳转下一步
    next(type) {
      if (type == "next") {
        //下一步
        // if (this.detail.action == 1 || this.detail.action == 4) {
        //   this.toPath();
        // } else {
        //   this.$message.warning("请完善信息!");
        // }
        if (this.detail.action >= 2) {
          this.toPath();
        } else if (this.detail.is_verify == 1) {
          this.$message.warning("请完善信息!");
        } else {
          this.toPath();
        }
      } else if (type == "skip") {
        //跳过
        this.skipOrReadStep(1);
      } else if (type == "known") {
        //已知悉
        this.skipOrReadStep(2);
      }
    },
    // 跳过或者已知悉
    skipOrReadStep(action) {
      let data = {
        action,
        mark: this.detail.mark,
      };
      skipOrReadStep(data)
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success("操作成功");
            this.toPath();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toPath() {
      this.active = this.active + 1;
      let { link_url, id } = this.stepMenuList[this.active];
      if (link_url == "conference") {
        this.$router.push({
          path: link_url,
          query: {
            id
          },
        });
      } else {
        this.$router.push({
          path: link_url,
        });
      }
    },
    // 下载pdf
    down(url) {
      window.open(url, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.content .el-button {
  color: #fff;
  position: absolute;
  bottom: 30px;
  left: 50%;
  background: #008dff;
}
.details-tips {
  padding: 20px;
  font-size: 15px;
  color: #1d1d1d;
  margin-top: 20px;
  line-height: 22px;
  background: #fff;
  border-radius: 10px;
}
.conf-btn {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  .btn {
    min-width: 148px;
    height: 40px;
    cursor: pointer;
    font-size: 19px;
    margin: 0 10px;
    font-weight: 500;
    color: #2690e6;
    line-height: 40px;
    text-align: center;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #008dff;
    &:hover {
      text-decoration: underline;
    }
  }
  .next-btn {
    color: #fff;
    background: #008dff;
  }
}
/deep/ .el-form-item__label {
  font-size: 20px;
  font-weight: 600;
}

.search {
  bottom: initial !important;
  left: 40% !important;
}
.te-right {
  border: 1px solid #008dff;
  color: #2690e6;
  text-align: center;
  padding: 6px 20px;
  box-sizing: border-box;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}
.t_list {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.down-btn {
  cursor: pointer;
}
.rich-text {
  cursor: pointer;
  max-height: 500px;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }
}
.edit-content /deep/ img {
  max-width: 100%;
}
/deep/ .el-input {
  width: 30%;
}
@media only screen and (max-width: 1280px) {
  .template-list {
    width: 100%;
    margin-right: 0 !important;
  }
}
@media only screen and (max-width: 767px) {
  /deep/ .el-input {
    width: 90%;
  }
  .t_list {
    margin-top: 30px;
  }
  .content .el-button {
    position: initial !important;
    margin-top: 20px;
  }
  .content {
    min-height: calc(100vh - 60px);
    padding: 0 0 130px 0;
  }
  .template-list {
    width: 100%;
    margin: 0 auto 20px;
    // margin: 0px 20px 20px 20px;
    height: initial !important;
    padding: 0px 30px 10px 31px;
  }
  .file-time {
    font-size: 12px !important;
    margin-top: 2px !important;
  }
  .file-num {
    margin-top: 2px !important;
  }
  .content .el-button {
    font-size: 15px !important;
  }
  .file-name {
    font-size: 16px !important;
    line-height: 22px !important;
  }
  .t_list {
    padding-bottom: 0px;
  }
  .main-sub {
    margin-left: 30px;
  }
}
</style>
<style scoped>
.el-select {
  width: 30%;
}
@media only screen and (max-width: 767px) {
  .el-select {
    width: 90%;
  }
}
</style>